<template>
  <div class="landing">
    <h1 id="headline">Braeton SDA Church Mobile App</h1>
    <div class="info-row row">
      <div class="col-12 col-md-6">
        <h3>
          Stay connected and up to date with the
          Braeton Seventh-day Adventist Church's Mobile Application.
        </h3>
        <h5 class="features">
          <div class="span-feat">Main features include:</div>
          <br />
          <ul>
            <li>Daily Bible Text</li>
            <li>Announcements</li>
            <li>Sabbath Programme</li>
            <li>Audio Sermons</li>
            <li>Resources</li>
          </ul>
        </h5>
        <!--action-->
        <div class="flex social-btns">
          <a
            class="app-btn blu flex vert"
            href="https://apps.apple.com/us/app/braeton-sda-church/id1435249098"
          >
            <i class="fab fa-apple"></i>
            <p class="sbtn">
              Available on the
              <br />
              <span class="big-txt">App Store</span>
            </p>
          </a>

          <a
            class="app-btn blu flex vert"
            href="https://play.google.com/store/apps/details?id=com.braetonsda.bsda"
          >
            <i class="fab fa-google-play"></i>
            <p class="sbtn">
              Get it on
              <br />
              <span class="big-txt">Google Play</span>
            </p>
          </a>
        </div>

        <!--action-->
      </div>
      <div class="col-12 col-md-6">
        <img
          class="img-responsive app-img"
          alt="Braeton SDA App Splash"
          src="../assets/splash.jpeg"
        />
        <img class="img-responsive app-img" alt="Braeton SDA App Home" src="../assets/home.jpeg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "landing",
  mounted() {
    let page = this.$route.query.page;
    if (!page) {
      page = "";
    } else {
      page = "/" + page;
    }
    if (this.$device.android) {
      setTimeout(function() {
        window.location =
          "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.braetonsda.bsda";
      }, 2000);
      window.location = "braetonsda://braetonsda-app.com" + page;
    }

    if (this.$device.ios) {
      setTimeout(function() {
        window.location =
          "https://apps.apple.com/us/app/braeton-sda-church/id1435249098";
      }, 2000);
      window.location = "braetonsda://braetonsda-app.com" + page;
    }
  }
};
</script>

<style>
@import "https://use.fontawesome.com/releases/v5.3.1/css/all.css";
</style>
<style lang="scss" scoped>
.landing {
  margin: 30px 0;
  color: #333333;
}
#headline {
  font-weight: bold;
}
.app-img {
  max-width: 250px;
  padding: 5px;
  margin: 0 5px;
  border-radius: 20px;
  border: 1px solid #333333;
}
.info-row {
  margin-top: 30px;
}
.features {
  margin-top: 20px;
  color: #3d4849;
}

// app store
.flex {
  display: flex;
  align-items: center;
}

.app {
  &-btn {
    justify-content: center;
    width: 45%;
    max-width: 160px;
    color: #fff;
    margin: 20px 10px;
    text-align: left;
    border-radius: 5px;
    text-decoration: none;
    font-family: "Lucida Grande", sans-serif;
    font-size: 10px;
    text-transform: uppercase;
    &.blu {
      background-color: #101010;
      transition: background-color 0.25s linear;
      &:hover {
        background-color: #454545;
      }
    }
    i {
      width: 20%;
      text-align: center;
      font-size: 28px;
      margin-right: 7px;
    }
    .big-txt {
      font-size: 17px;
      text-transform: capitalize;
    }
  }
}
.sbtn {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
